export default __webpack_public_path__ + "static/media/pools-banner-2.3127fb15.png";